import styled from 'styled-components'
import { belowTablet } from 'utilities/styled'
import { Rows, FlexChildGrow } from 'components/flex'
import Paragraph from 'components/typography/paragraph'
import Modal from 'modals/dialog'

export const Herows = styled(Rows)`
    row-gap: 16px;
`

export const ModalBody = styled(Modal.Body)`
    overflow: clip;
    overflow-clip-margin: 4px;
    display: grid;
    grid-template-rows: max-content 1fr;

    margin-block-end: calc(var(--__huma-component-modal-row-gap) * -1);

    &:has(> :only-child) {
        grid-template-rows: 1fr;
    }
`

export const ContentRow = styled(FlexChildGrow)`
    overflow-y: auto;
`

export const EmptyContainer = styled.div`
    padding: 16px 32px;

    text-align: center;

    > * {
        margin: 0 auto;
    }
`

export const Status = styled(Paragraph)`
    padding-block-end: 8px;
    padding-inline: 32px;

    text-align: center;
    line-height: 40px;

    ${belowTablet`
        padding-inline: 24px;
    `}
`